import React from 'react';

const SectionTitle = (props) => {
  const { itemClass, subTitleClass, subTitle, titleClass, title } = props;
  return (
    <div className={itemClass ? itemClass : 'it-service-title-box'}>
      <span className={subTitleClass ? subTitleClass : 'it-section-subtitle'}>
        {subTitle ? subTitle : 'OUR SERVICES'}
      </span>
      <h3 className={titleClass ? titleClass : 'it-section-title'}>
        {title ? title : 'Services We Provide.'}
      </h3>
    </div>
  );
};

export default SectionTitle;
